import enCA from "./en-CA";
import frCA from "./fr-CA";

const messages = {
  "en-CA": enCA,
  "fr-CA": frCA,
};

export default messages;



// WEBPACK FOOTER //
// ./src/components/intl/messages.js